import React from 'react';
import BarSummary from './BarSummary';
import { Producer, SummaryProducer, ShipmentSummary, Branch } from '../Models/Report';
import FilterReport from './FilterReport';
import { ScreenSelection } from './ScreenSelection';
import Loading from './Loading';
import { capitalize } from '../Utils/StrUtil';

export interface ICardSummaryAnnual {
	producers: Producer[];
	shipmentData?: ShipmentSummary;
	request: boolean;
	onSummary: (idProducer: string, idBranch: number) => void;
}

const CardSummaryAnnual = (props: ICardSummaryAnnual) => {
	const [producer, setProducer] = React.useState(props.producers.length === 1 ? props.producers[0].id : undefined);
	const getProducer = (idProducer?: string) => {
		const currentProducer = idProducer || producer;
		const current = props.producers.find(p => p.id === currentProducer);
		if (!current && props.producers.length === 1) {
			return props.producers[0];
		} else {
			return current;
		}
	}
	// eslint-disable-next-line
	const [branch, setBranch] = React.useState<number>(99);
	const [isReady, setReady] = React.useState<boolean>(false);
	const [objProducer, setObjProducer] = React.useState(getProducer())
	// eslint-disable-next-line
	const [announced, setAnnounced] = React.useState<SummaryProducer>();

	const onChangeBranch = (idBranch: string | number) => {
		setBranch((idBranch || 99) as number)
	}

	const onChangeProducer = (idProducer: string | number) => {
		const current = props.producers.find(p => p.id === idProducer);
		if (current) {
			setAnnounced(current.summary);
		}
		setProducer(idProducer as string);
		setBranch(99);
		setObjProducer(getProducer(idProducer as string))
		props.onSummary(idProducer as string, 99);
	}


	const getBranch = (branch: number) => {
		let res: any =  undefined;
		if (producer) {
			const current = props.producers.find(p => p.id === producer);
			if (current) {

				return current.branchs.find(b => b.id === branch);
			}
			return null;
		}
		for (let i = 0; i < props.producers.length; i += 1) {
			const current = props.producers[i];
			for (let j = 0; j < current.branchs.length; j += 1) {
				if (current.branchs[j].id === branch) {
					return current.branchs[j];
				}
			}
		}
		return res;
	}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	React.useEffect(() => {
		if(props.producers.length === 1 && !isReady) {
			setReady(true);
			const producer = props.producers[0];
			setObjProducer(producer)
			setProducer(producer.id);
			props.onSummary(producer.id, branch);
		}
	});
	return (

			<div>
				<Header branch={getBranch(branch)} producer={objProducer} />
				<FilterReport
						disabled={props.request}
						selected={objProducer}
						onChangeBranch={onChangeBranch}
						onChangeProducer={onChangeProducer}
						producers={props.producers}
						ignoreFilter={true}
					/>
				{props.request && <Loading />}
				{(!producer && !props.request)  &&   <ScreenSelection />}
				{props.shipmentData && !props.request && objProducer && <BarSummary producer={props.producers.find(p => p.id === producer)} branch={getBranch(branch)} data={props.shipmentData} />}
			</div>
		)
}

export interface IHeader {
	branch?: Branch;
	producer?: Producer;
}

export const Header = (props: IHeader) => (<div>
		<h1>Resumen Anual {props.branch ? 'Faena' : 'Minera'} <span>{props.producer && props.producer.name}</span> <span>{props.branch && " / " + capitalize(props.branch.name)}</span></h1>
				<p>Gráfico comparativo por estado de carga</p>
</div>)

export default CardSummaryAnnual;
